import { Tooltip } from '@mantine/core';
import { RichTextEditor, useRichTextEditorContext } from '@mantine/tiptap';
import IconBulletList from 'components/inputs/wysiwyg/controls/bullet-list/IconBulletList';

/**
 * Used to insert bullet list.
 */
export default function ControlBulletList() {
  const { editor } = useRichTextEditorContext();
  return (
    <Tooltip label="Bullet list" openDelay={100} closeDelay={50}>
      <RichTextEditor.Control
        onClick={() => editor?.chain().focus().toggleBulletList().run()}
        active={editor?.isActive('bulletList')}
      >
        <IconBulletList />
      </RichTextEditor.Control>
    </Tooltip>
  );
}
